export default __webpack_public_path__ + "static/media/timeline.910efe34.svg";